export default __webpack_public_path__ + "static/media/black3.891591e1.gif";